import { Input, ViewChild, Directive } from '@angular/core';

@Directive()
export class BaseUIComponent {
    // Audit Related Fields
    @Input() className = 'none';
    @Input() title;
    @ViewChild('domElement') domEl;
    @Input() disabled: boolean;


    @Input() mandatory: string;
    @Input() visible = 'true';
    @Input() readOnly = 'false';
    @Input() enabled = 'true';

    @Input() width: string;

    isReadOnly = false;
    isEnabled = true;

    protected timestamp: any;
    protected length = 8;

    generateId() {
        this.timestamp = +new Date;
        let ts = this.timestamp.toString();
        let parts = ts.split( '' ).reverse();
        let id = '';

        for ( let i = 0; i < this.length; ++i ) {
           let index = this.getRandomInt( 0, parts.length - 1 );
           id += parts[index];
        }
        return id;
    }

    getRandomInt( min, max ) {
        return Math.floor( Math.random() * ( max - min + 1 ) ) + min;
    }


    set ForeColor(color) {
        this.domEl.nativeElement.style.color = color;
    }

    set ReadOnly(arg) {
       this.readOnly = arg.toString().toLowerCase();
       this.determineClassNameForDOM();
    }

    get ReadOnly() {
        if (this.readOnly && this.readOnly.toLowerCase() == 'true') {
            return true;
        }
        return false;
     }

    set Enabled(enable) {
        this.enabled = enable.toString().toLowerCase();
        this.determineClassNameForDOM();
    }

    get Enabled() {
        if (this.enabled && this.enabled.toLowerCase() == 'false') {
            return false;
        }
        return true;
    }

    set Visible(visible) {
        this.visible = visible.toString().toLowerCase();
        this.determineClassNameForDOM();
    }

    get Visible() {
        if (this.visible && this.visible.toLowerCase() == 'false') {
            return false;
        }
        return true;
    }

    get Mandatory() {
        if (this.mandatory && this.mandatory.toLowerCase() == 'true') {
            return true;
        }
        return false;
    }

    get EditOperationAllowed(): boolean {
        if (!this.Enabled || this.ReadOnly) {
            return false;
        }
        return true;
    }

    determineClassNameForDOM() {

    }

    Focus() {

    }

    focus() {

    }
}


